import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enUS from 'date-fns/locale/en-US';
import { formatISO, parse, setHours, setMinutes } from 'date-fns';
import { es } from 'date-fns/locale';


registerLocale('es',es)

const DatePickerBlock = ({ task, ganttMet, excluded, rangeTime,updateTask }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [durationInDays,setDurationInDays] = useState("")
  const [durationInHours , setDurationInHours] = useState("")
  const [timeRange,setTimeRange]= useState({minTime :null, maxTime : null})
 
  const durationInDaysfn = (start,end)=> {
    let days  = (ganttMet.calculateDuration(start,end, "hours") / 9);
    let roundedDays = Math.round(days * 100) / 100; // Redondea a 2 decimales
    setDurationInDays(Number.isInteger(roundedDays) ? roundedDays : roundedDays.toFixed(2));
    /* setDurationInDays(days) */
  } 

  const durationInHoursfn = (start,end)=> {
    let hours  = (ganttMet.calculateDuration(start,end, "hours"));
    setDurationInHours(hours)
  } 

  useEffect(()=>{
    if(task) {
      setStartDate(new Date(task.start_date))
 
      setEndDate( new Date(task.end_date))
    }
   
  },[task, ganttMet,updateTask])
  
  useEffect(()=>{
    if(startDate && endDate ){
      durationInDaysfn(startDate,endDate)
      durationInHoursfn(startDate,endDate)
    }

  },[task,startDate,endDate,])

  const handleStartDateChange = (date) => {
    setStartDate(date);
    ganttMet.getTask(task.id).start_date = date
  };

  const handleEndDateChange = (date) => {
    console.log(date)
    if (date < startDate) {
      date = startDate;
    }
    setEndDate(date);
    ganttMet.getTask(task.id).end_date = date;
  };


  const convertToISO = (date) =>{
    const parseDate  = parse(date,'yyyy/MM/dd' , new Date())
    return  parseDate
  }

  const allExcludeDates = excluded?.map((date) => {
    return convertToISO(date)
    //new Date(date)
  } );


  const getTimeForDay=(day,type)=>{
    const timeConfig = rangeTime[day]
    if(!timeConfig || timeConfig?.minTime == null || timeConfig?.maxTime == null ) return null
    const [hours, minutes]= timeConfig[type]
    
    if(type == "minTime") {
      return setHours(setMinutes( new Date(), minutes),(hours - 1))
    }else {
      return setHours(setMinutes( new Date(), minutes),hours)
    }

  }
   const getfilterDay = (date) =>{
   
    const day = date.getDay()
    const hasJournaly = rangeTime[day]
    if( hasJournaly?.minTime  ||  hasJournaly?.maxTime)
    {
      return rangeTime[day]
    }
 /*    const match  = 
    return date.getDay() !== 6 && date.getDay() !== 0 */
   }
  return (
    <>
    <div className='d-flex mb-3 ml-1' style={{gap:"40px", width:"70%"}}>
      <div className=''>
        <span style={{fontSize:"13px"}} className='ml-1'>Duración (días) : </span>
        <span style={{fontSize:"13px"}} >{durationInDays} </span>
      </div>
      <div className=''>
        <span  style={{fontSize:"13px"}} className='ml-1'>Duración (horas) : </span>
        <span style={{fontSize:"13px"}} >{durationInHours} </span>
      </div>
    </div>
    <div className='gantt_cal_ltext' style={{display:'flex', justifyContent:'space-evenly'}}>
      <ReactDatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        showTimeSelect
        dateFormat='dd-MM-yyyy HH:mm'
        className='gantt_input'
        locale = "es"
        excludeDates={allExcludeDates}
  /*       todayButton="Hoy" */
        showYearDropdown
        yearDropdownItemNumber={5}
        scrollableYearDropdown
       /*  dropdownMode="select" */
        timeIntervals ={30}
        minTime = {getTimeForDay(startDate?.getDay(),"minTime")}
        maxTime = {getTimeForDay(startDate?.getDay(),"maxTime")}
        filterDate ={(date)=>getfilterDay(date)}
      />
      <ReactDatePicker
        selected={endDate}
        onChange={handleEndDateChange}
        showTimeSelect
        dateFormat='dd-MM-yyyy HH:mm'
        className='gantt_input'
        timeIntervals ={30}
        showYearDropdown
        yearDropdownItemNumber={5}
        scrollableYearDropdown  
        minDate={startDate}
/*         todayButton="Hoy" */
        locale = "es"
        startDate={startDate}
        excludeDates={allExcludeDates}
        minTime = {getTimeForDay(startDate?.getDay(),"minTime")}
        maxTime = {getTimeForDay(startDate?.getDay(),"maxTime")}
        filterDate  = {(date)=>getfilterDay(date)}
        /* filterDateEnd ={(date)=>getfilterDay(date)} */

      />
    </div>
    </>
    );
};

export default DatePickerBlock;